// React
import { useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

// MUI
import { Stack } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers";

// Auth
import { MBSAuthProvider } from "Auth/MBS/MBSAuthContext";

// Components
import { BackgroundBlob } from ".";

// Constants
import { MODES } from "Constants/theme";
import { MBSTheme } from "Theme";

// Utils
import { getSystemMode, isValidMode } from "Utils/ColourUtils";

const MBSLayout = () => {
  const location = useLocation();
  const [modePreference, setModePreference] = useState(() => {
    try {
      const stored = localStorage.getItem("theme.modePreference");
      return isValidMode(stored) ? stored : MODES.LIGHT;
    } catch {
      return MODES.LIGHT;
    }
  });

  const effectiveMode =
    modePreference === MODES.SYSTEM ? getSystemMode() : modePreference;

  const handleModePreferenceChange = (nextPreference) => {
    const nextMode = isValidMode(nextPreference) ? nextPreference : MODES.LIGHT;
    setModePreference(nextMode);
    localStorage.setItem("theme.modePreference", nextMode);
  };

  const mbsTheme = useMemo(() => MBSTheme(effectiveMode), [effectiveMode]);
  const isLoginRoute = location.pathname === "/mbs/login";

  return (
    <MBSAuthProvider>
      <ThemeProvider theme={mbsTheme}>
        <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="en">
          <Stack
            sx={{
              display: "block",
              minWidth: 0,
              width: "100%",
              minHeight: "100vh",
              position: "relative",
              overflowX: "hidden",
              overflowY: "auto",
              bgcolor: "background.default",
            }}
          >
            <BackgroundBlob
              mode={effectiveMode}
              withNavbarOffset={!isLoginRoute}
            />
            <Stack sx={{ display: "block", position: "relative", zIndex: 1 }}>
              <Outlet
                context={{
                  modePreference,
                  onModePreferenceChange: handleModePreferenceChange,
                }}
              />
            </Stack>
          </Stack>
        </LocalizationProvider>
      </ThemeProvider>
    </MBSAuthProvider>
  );
};

export default MBSLayout;
